/**
 * @项目名称: bjxy
 * @功能名称: 脱离业务的公共功能初始化，所有业务引入，以后有全局公共的依赖只需要这这里引入，会打包为一个独立的script 标签加载
 * @文件名称: common
 * @Date: 2018/11/27
 * @Author: liux
 * @Copyright（C）2018 「小赢科技」 Inc.   All rights reserved.
 * 注意：本内容仅限于「小赢科技」内部传阅，禁止外泄以及用于其他的商业目的。
 */
import badjs from './xyHelper/badjs'
badjs({id:15});
import MtaH5 from 'mta-h5-analysis'
MtaH5.init({
  "sid":'500649902', //必填，统计用的appid
  "cid":'', //如果开启自定义事件，此项目为必填，否则不填
  "autoReport":1,//是否开启自动上报(1:init完成则上报一次,0:使用pgv方法才上报)
  "senseHash":1, //hash锚点是否进入url统计
  "senseQuery":1, //url参数是否进入url统计
  "performanceMonitor":0,//是否开启性能监控
  "ignoreParams":[] //开启url参数上报时，可忽略部分参数拼接上报
});
// 全局加载vue指令
import './vuePlugin/directive'

import './helper/jsReset';
import './base.css';
